<template>
  <div>
    <span v-if="isCommandKey" class="aha-key ml-1">
      ⌘
    </span>
    <span v-if="isControlKey" class="aha-key ml-1">
      Ctrl
    </span>
    <span v-if="hasShift" class="aha-key ml-1">
      Shift
    </span>
    <span v-if="keyName" class="aha-key ml-1">
      {{ keyName }}
    </span>
  </div>
</template>

<script>
import navigator from '../../utils/navigator'

export default {
  name: 'AhaKey',
  props: {
    keyName: {
      type: String,
      default: null,
    },
    hasShift: {
      type: Boolean,
      default: false,
    },
    hasAlt: {
      type: Boolean,
      default: false,
    },
    hasCtrl: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCommandKey() {
      return navigator.isMacOS() && this.hasCtrl
    },
    isControlKey() {
      return !navigator.isMacOS() && this.hasCtrl
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-key {
  font-size: 0.8rem;
  display: inline-block;
  padding: 0.1875rem 0.25rem;
  line-height: 1;
  @apply text-base-90 px-1.5 bg-base-20 rounded border-0.5 border-base-60;
}
</style>
